import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../../application/config/config';
import Fetch from "../../../../core/util/core/Fetch";

function Form() {

    const session = getUserSession();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/companies/';
    const paths = {
        endpointSave: config.endpoints.backend + 'companies/save',
        endpointGetById: config.endpoints.backend + 'companies/getById',
        endpointGetAll: config.endpoints.backend + 'companies/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Empresa",
        labelTitleEdit: "Editar Empresa",
        labelTitleView: 'Visualizar Empresa'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                core_application_instance_id: session.user.application_instance_id,
                core_user_id: session.user.id
            },
            fields: [
                {
                    name: 'cnpj',
                    type: 'CNPJ',
                    label: 'CNPJ',
                    validations: {
                        required: true,
                        cnpj_unique: true
                    },
                    columnSize: 12
                },
                {
                    name: 'corporate_name',
                    type: 'text',
                    label: 'Razão social',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome Fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'municipal_registration',
                    type: 'text',
                    label: 'Inscrição Municipal',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'estadual_registration',
                    type: 'text',
                    mask: '999.999.999.999',
                    label: 'Inscrição Estadual',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'link',
                    type: 'text',
                    label: 'Link',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Anexo',
                    uploadPath: '/companies/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'institutional_email',
                    type: 'email',
                    label: 'Email Institucional',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                cnpj_unique: async (value, options, key, attributes) => {
                    if (value.length >= 18) {
                        const cnpjExists = await Fetch.post(paths.endpointGetAll, { filter: { cnpj: value }, deleted: true })

                        if (cnpjExists.length > 0) {
                            if (id && cnpjExists[0].id == id) {
                                return '';
                            } else {
                                if (cnpjExists[0].deleted == 1) {
                                    return '^Existem registros de empresas deletados com esse CNPJ, crie um chamado para administração se necessário.';
                                } else {
                                    return '^Já existe uma empresa cadastrada com esse CNPJ.';
                                }
                            }
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
